import { render } from "./AppOffline.vue?vue&type=template&id=859634e6&scoped=true"
import script from "./AppOffline.vue?vue&type=script&lang=js"
export * from "./AppOffline.vue?vue&type=script&lang=js"

import "./AppOffline.vue?vue&type=style&index=0&id=859634e6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-859634e6"]])

export default __exports__